import * as actionTypes from './actionTypes';


// create student psychology request
export function saveSchoolPsychologyRequest(payload) {
  return { type: actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST, payload };
}
export function saveSchoolPsychologyRequestSuccess(payload) {
  return { type: actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS, payload: payload };
}

// get student psychology request
export function getSchoolPsychologyRequest(payload) {
  return { type: actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST, payload };
}
export function getSchoolPsychologyRequestSuccess(payload) {
  return { type: actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS, payload: payload };
}


